export const debounce = (func, delay) => {
    let timeoutId;
    
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };